import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid } from '@mui/material'

import Button from './Button'
import Dialog from './Dialog'
import GridInputField from './GridInputField'
import GridCircularProgress from './GridCircularProgress'
import DialogImpostazioniMailTest from './DialogImpostazioniMailTest'
import { formatBodyField } from '../hooks/utils-functions'
import { config } from '../settings/configs'
import {
  useGetImpostazioniMailQuery,
  useTestMailMutation,
} from '../hooks/api-slice'
import { titlesImpostazioni } from '../settings/settings'
import { setImpostazioniMail } from '../container/home'

const DialogImpostazioniMail = ({ open, handleClose, triggerFunction }) => {
  const impostazioniMail = useSelector(state => state.home.impostazioniMail)
  const { data: impoMail, isLoading } = useGetImpostazioniMailQuery()

  const [testMailMutation] = useTestMailMutation()

  const dispatch = useDispatch()

  useEffect(() => {
    if (open) dispatch(setImpostazioniMail(impoMail))
  }, [dispatch, impoMail, open])

  const [openTest, setOpenTest] = useState()
  const handleClickOpenTest = () => setOpenTest(true)
  const handleCloseTest = () => setOpenTest()

  const confirmTest = async (from, to) => {
    const body = { from, to }
    const result = await testMailMutation(body)
    if (!result?.error) handleCloseTest()
  }

  const cDispatch = (field, value) =>
    dispatch(
      setImpostazioniMail({
        ...impostazioniMail,
        [field]: formatBodyField(value),
      }),
    )

  const MyGridInputField = (label, field, type) => (
    <GridInputField
      label={label}
      field={field}
      value={impostazioniMail?.[field]}
      onChange={cDispatch}
      type={type}
    />
  )

  const MyTitle = ({ title }) => (
    <Grid marginTop={2} marginBottom={1} sx={{ width: '100%' }}>
      <b>{title}</b>
    </Grid>
  )

  useEffect(() => {
    if (!open) dispatch(setImpostazioniMail())
  }, [dispatch, open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={triggerFunction}
      title={titlesImpostazioni.titleMail}
      textConfirm='Salva'
      maxWidth='md'
    >
      {isLoading ? (
        <GridCircularProgress />
      ) : (
        <>
          Credenziali per l'invio delle mail automatiche.
          <br />
          <Grid
            container
            alignItems='center'
            rowSpacing={1}
            columnSpacing={2}
            sx={{ width: '100%' }}
          >
            <MyTitle title='Server SMTP' />
            {MyGridInputField('Host', 'MailHost')}
            {MyGridInputField('Port', 'MailPort', 'number')}
            {config?.features?.iscrizioni && (
              <>
                <MyTitle title='Iscrizioni' />
                {MyGridInputField('Mail', 'MailIscrizioniUser')}
                {MyGridInputField('Password', 'MailIscrizioniPass')}
              </>
            )}
            {config?.features?.spostamenti && (
              <>
                <MyTitle title='Spostamenti' />
                {MyGridInputField('Mail', 'MailSpostamentiUser')}
                {MyGridInputField('Password', 'MailSpostamentiPass')}
              </>
            )}
            {config?.features?.calendari && (
              <>
                <MyTitle title='Risultati' />
                {MyGridInputField('Mail', 'MailRisultatiUser')}
                {MyGridInputField('Password', 'MailRisultatiPass')}
              </>
            )}
            {(config?.features?.arbitraggi ||
              config?.features?.designazioni) && (
              <>
                <MyTitle title='Arbitri' />
                {MyGridInputField('Mail', 'MailArbitriUser')}
                {MyGridInputField('Password', 'MailArbitriPass')}
              </>
            )}
            &nbsp;
            <Grid size={12}>
              <center>
                <Button onClick={handleClickOpenTest}>Test</Button>
              </center>
            </Grid>
          </Grid>
          <DialogImpostazioniMailTest
            open={openTest}
            handleClose={handleCloseTest}
            triggerFunction={confirmTest}
          />
        </>
      )}
    </Dialog>
  )
}

export default DialogImpostazioniMail
